export default __webpack_public_path__ + "static/media/hospital-background-images-hd-9.a9fc08c3.jpg";